import { DEALS_FEATURE } from '@/constants/experimentConstants';
import DealsSearchPage, { useDealsPageType } from '@/features/deals/pages/DealsSearchPage';
import { useConfidenceFlag } from '@/hooks/useConfidenceFlag';
import SERP from '@/pages/list';

function DealsSearchPageWrapper(props) {
  const type = useDealsPageType();
  const { flagValue } = useConfidenceFlag(DEALS_FEATURE.name, DEALS_FEATURE.defaultValue, false);
  const dealsEnabled = flagValue.enabled;

  if (type === 'deals_sistaminuten' && !dealsEnabled) {
    return <SERP type="sistaminuten" />;
  }

  return <DealsSearchPage {...props} />;
}

export default DealsSearchPageWrapper;
